<template>
	<div class="paymentHistory">
		<div class="wrapper">
			<div class="search-input">
				<b-form-input
					class="input-search"
					:placeholder="$t('userDashboard.messages.search')"
					v-model="searchQuery"
				></b-form-input>
				<MagnifyIcon class="icon-search" />
			</div>
			<div class="date-pickers">
				<datepicker
					class="date-input"
					:language="th"
					v-model="dateFrom"
				></datepicker>
				<div class="text">{{ $t('paymentHistory.to') }}</div>
				<datepicker
					class="date-input"
					:language="th"
					v-model="dateTo"
				></datepicker>
			</div>
			<b-dropdown class="input-choose" no-flip>
				<template v-slot:button-content>
					{{ selectedFilter.value }}
					<ChevronDownIcon />
				</template>
				<b-dropdown-item
					v-for="(filter, k) in filterBy"
					:key="k"
					@click="selectedFilter = filter"
					>{{ filter.value }}</b-dropdown-item
				>
			</b-dropdown>
			<div class="wrap-btn-search">
				<b-button
					class="btn-search"
					id="fetchUserPayments"
					@click="fetchUserPayments(true)"
					>{{ $t('paymentHistory.search') }}</b-button
				>
			</div>
		</div>

		<div
			v-if="userPayments.length == 0 || loading"
			class="wrap-list text-center"
		>
			<b-spinner
				v-if="loading"
				label="Loading..."
				variant="'primary'"
			></b-spinner>
			<p v-else>{{ $t('payment.youHaveNoPayments') }}</p>
		</div>
		<div v-else class="wrap-list">
			<b-table sticky-header :fields="fields" :items="userPayments">
				<template v-slot:cell(id)="data">
					<div>{{ data.item.order_id }}</div>
				</template>
				<template v-slot:cell(created_at_day)="data">
					<div>
						{{
							data.item.updated_at
								| formatDate($router.currentRoute.params.lang)
						}}
					</div>
				</template>
				<template v-slot:cell(created_at_time)="data">
					<div>
						{{ data.item.updated_at | formatHour('en') }}
					</div>
				</template>
				<template v-slot:cell(total_amount)="data">
					<div>{{ parseFloat(data.item.total_amount).toLocaleString("th-TH") }} {{ $t('baht') }}</div>
				</template>
				<template v-slot:cell(status)="data">
					<div v-if="data.item.status == 1" class="success">
						{{ $t('payment.statuses.created') }}
					</div>
					<div v-else-if="data.item.status == 2" class="pending">
						{{ $t('payment.statuses.processing') }}
					</div>
					<div v-else-if="data.item.status == 3" class="success">
						{{ $t('payment.statuses.completed') }}
					</div>
					<div v-else-if="data.item.status == 4" class="unsuccess">
						{{ $t('payment.statuses.fail') }}
					</div>
					<div v-else-if="data.item.status == 6" class="success">
						{{ $t('payment.statuses.refund') }}
					</div>
					<div v-else-if="data.item.status == 7" class="success">
						{{ $t('payment.statuses.awaitingPayment') }}
					</div>
				</template>
				<template v-slot:cell(tooltip)="data">
					<div class="success">
						<span
							v-if="
								data.item.listing
							"
							@click="gotoListingDetails(data.item.listing.id)"
							id="gotoListingDetails"
						>
							<EyeIcon />
						</span>
						<!-- <span v-if="data.item.status == 3">
                          <DownloadIcon />
                        </span> -->
						<span
							v-if="data.item.status == 4 || data.item.status == 3"
							@click="sendPaymentInvoice(data.item, data)"
						>
							<EmailIcon />
						</span>
						<span
							id="showPaymentDetails"
							@click="showPaymentDetails(data.item.id)"
							style="cursor:pointer;"
						>
							<IconFileDocumentOutline />
						</span>
					</div>
				</template>
			</b-table>

			<b-row cols="12" lg="12" class="text-center paginate-position">
				<div class="overflow-auto wrap-pagination d-none d-md-block">
					<b-pagination-nav
						v-model="page"
						class="paginate-item"
						:prev-text="$t('nextPg')"
						:next-text="$t('prevPg')"
						:link-gen="paginationNumber"
						:number-of-pages="
							pageInfo && pageInfo.pageCount ? pageInfo.pageCount : 1
						"
						use-router
					></b-pagination-nav>
				</div>
			</b-row>
		</div>
		<div>
			<b-modal
				id="payment-details-dialog"
				body-class="payment-details-dialog"
				class="my-modal"
				centered
				hide-footer
				hide-header
				size="lg"
			>
				<b-container fluid v-if="userPaymentsDetails">
					<div class="header" style="margin: 10px;">
						<div class="title">Order{{ userPaymentsDetails.id }} <b-button class="btn-grid btn-primary active" @click="copyText(userPaymentsDetails.id)"><IconCopy style="width:15px;height:15px;"/></b-button></div>
						<div @click="hideModal" class="close-modal">
							<CloseIcon />
						</div>
					</div>
					<div style="padding: 0 20px 20px;">
						
						<span style="font-weight:bold;">{{ $t('bill.name') }} :</span>
						{{ userPaymentsDetails.user.name }} <b-button class="btn-grid btn-primary active" @click="copyText(userPaymentsDetails.user.name)"><IconCopy style="width:15px;height:15px;"/></b-button>
						<br />
						<span style="font-weight:bold;">{{ $t('user.email') }} :</span>
						<a :href="'mailto:'+userPaymentsDetails.user.email" style="color:var(--projectPrimaryColor);">{{ userPaymentsDetails.user.email }}</a>
						<b-button class="btn-grid btn-primary active" @click="copyText(userPaymentsDetails.user.email)"><IconCopy style="width:15px;height:15px;"/></b-button>
						<br />
						<!-- <span v-if="userPaymentsDetails.payment_method_id!==4 && userPaymentsDetails.payment_method_id!==5 && userPaymentsDetails.payment_method_id!==1&& userPaymentsDetails.payment_method_id!==7">
							<span style="font-weight:bold;" >{{ $t('bill.userId') }} :</span>
							{{ userId }} <b-button class="btn-grid btn-primary active" @click="copyText(userId)"><IconCopy style="width:15px;height:15px;"/></b-button>
							<br />
							<span style="font-weight:bold;" >{{ $t('bill.paymentId') }} :</span>
							{{ paymentId }} <b-button class="btn-grid btn-primary active" @click="copyText(paymentId)"><IconCopy style="width:15px;height:15px;"/></b-button>
							<br />
							<span style="font-weight:bold;" >{{ $t('bill.chargeId') }} :</span>
							{{ chargeId }} <b-button class="btn-grid btn-primary active" @click="copyText(chargeId)"><IconCopy style="width:15px;height:15px;"/></b-button>
							<br />
							<span style="font-weight:bold;" >{{ $t('bill.totalAmount') }} :</span>
							{{ totalAmount }} <b-button class="btn-grid btn-primary active" @click="copyText(totalAmount)"><IconCopy style="width:15px;height:15px;"/></b-button>
							<br />
						</span> -->
					</div>
					<div class="body">
						<b-row
							class="row-with-space-between"
							v-for="packageDetails in userPaymentsDetails.user_payments_details"
							v-bind:key="packageDetails.id"
						>
							<div v-if="packageDetails.packages_coin != null">
								{{ packageDetails.packages_coin.name }}
								{{
									packageDetails.packages_coin.coin
										? ' - ' + packageDetails.packages_coin.coin
										: ''
								}}
							</div>
							<div v-if="packageDetails.packages_detail != null">
								{{ packageDetails.packages_detail.package.name }}
							</div>
							<div class="price">
								{{
									packageDetails.packages_detail != null &&
									packageDetails.packages_detail.num_days != null
										? packageDetails.packages_detail.num_days + `${$t('day')} - `
										: ''
								}}
								{{ parseFloat(packageDetails.price).toLocaleString("th-TH") }} {{ $t('baht') }}
							</div>
						</b-row>
					</div>
					<b-row class="body-footer">
						<div>
							{{ $t('payment.discount') }}
							<br />
							{{ $t('payment.sevenVat') }}
							<br />
							{{ $t('payment.serviceFee') }}
							<br />
							{{ $t('total') }}
						</div>
						<div class="price">
							{{ parseFloat(userPaymentsDetails.discount).toLocaleString("th-TH") }} {{ $t('baht') }}
							<br />
							{{ parseFloat(userPaymentsDetails.vat).toLocaleString("th-TH") }} {{ $t('baht') }}
							<br />
							{{ parseFloat(userPaymentsDetails.payment_fee).toLocaleString("th-TH") }} {{ $t('baht') }}
							<br />
							{{ parseFloat(userPaymentsDetails.total_amount).toLocaleString("th-TH") }} {{ $t('baht') }}
						</div>
					</b-row>
					<div
						class="payment-details-div"
						v-if="userPaymentsDetails.user_payments_logs.length || false"
					>
						<b-row class="table-header-row added-bottom-border">
							<div class="table-row" style="font-weight: bold;">
								{{ $t('payment.billingDate') }}
							</div>
							<div class="table-row" style="font-weight: bold;">
								{{ $t('payment.billingTime') }}
							</div>
							<div class="table-row" style="font-weight: bold;">
								{{ $t('payment.paymentMethod') }}
							</div>
							<div style="font-weight: bold;">{{ $t('payment.status') }}</div>
						</b-row>
						<b-row
							class="table-header-row"
							v-for="paymentLog in userPaymentsDetails.user_payments_logs"
							v-bind:key="paymentLog.id"
						>
							<div class="table-row">
								{{
									paymentLog.updated_at
										| formatDate($router.currentRoute.params.lang)
								}}
							</div>
							<div class="table-row">
								{{ paymentLog.updated_at | formatHour('en') }}
							</div>
							<div class="table-row">{{ paymentLog.payment_method.name }}</div>
							<div>
								<div v-if="paymentLog.status == 1" class="success">
									{{ $t('payment.statuses.created') }}
								</div>
								<div v-else-if="paymentLog.status == 2" class="pending">
									{{ $t('payment.statuses.processing') }}
								</div>
								<div v-else-if="paymentLog.status == 3" class="success">
									{{ $t('payment.statuses.completed') }}
								</div>
								<div v-else-if="paymentLog.status == 4" class="unsuccess">
									{{ $t('payment.statuses.fail') }}
								</div>
								<div v-else-if="paymentLog.status == 6" class="success">
									{{ $t('payment.statuses.refund') }}
								</div>
								<div v-else-if="paymentLog.status == 7" class="success">
									{{ $t('payment.statuses.awaitingPayment') }}
								</div>
							</div>
						</b-row>
					</div>
					<b-row class="button-div">
						<b-button
							class="primary"
							id="paymentCloseModal"
							@click="hideModal"
							>{{ $t('payment.close') }}</b-button
						>
					</b-row>
				</b-container>
			</b-modal>
		</div>
		<div>
			<b-modal
				id="sendMessage"
				class="my-modal"
				centered
				hide-footer
				hide-header
				size="md"
			>
				<b-container class="column">
					<div class="form-div">
						<label v-if="payment.status !== 4">{{$t('Email')}}</label>
						<label v-if="payment.status === 4">{{$t('Send a message to the user')}}</label>
						<b-textarea
							v-if="payment.status === 4"
							v-model="message"
						></b-textarea>
						<b-input
							v-if="payment.status !== 4"
							:placeholder="$t('Email')"
							v-model="email"
						></b-input>
					</div>
					<b-button
						class="primary send-button success-button"
						@click="sendMessageToUser(payment)"
						>{{$t('send')}}</b-button
					>
				</b-container>
			</b-modal>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
// Icons
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue';
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue';
import EyeIcon from '@/components/icons/IconEye/index';
// import DownloadIcon from "@/components/icons/IconDownload/index";
import EmailIcon from 'vue-material-design-icons/EmailOutline.vue';
import IconFileDocumentOutline from '@/components/icons/IconFileDocumentOutline/index';
import IconCopy from '@/components/icons/IconCopy/index';
import CloseIcon from 'vue-material-design-icons/Close.vue';

import * as actionType from '@/controllers/ActionTypes';
import Datepicker from 'vuejs-datepicker';
import { en, th } from 'vuejs-datepicker/dist/locale';
const moment = require('moment');

export default {
	components: {
		MagnifyIcon,
		Datepicker,
		IconCopy,
		EmailIcon,
		EyeIcon,
		IconFileDocumentOutline,
		CloseIcon,
		ChevronDownIcon
	},
	data() {
		return {
			freePayment:true,
			en: en,
			th: th,
			userPayments: [],
			userPaymentsDetails: {
				amount: null,
				barcode_url: null,
				updated_at: null,
				discount: null,
				id: null,
				listing: null,
				payment_fee: null,
				payment_method_id: null,
				status: null,
				total_amount: null,
				user: {
					email: null,
					name: null
				},
				user_payments_details: [],
				user_payments_logs: [],
				vat: null
			},
			page: this.$route.params.id ? this.$route.params.id : 1,
			pageInfo: { take: 10, itemCount: 0, page: 1, pageCount: 0 },
			searchQuery: '',
			dateFrom: null,
			dateTo: null,
			awaitingSearch: false,
			selectedFilter: {
				key: undefined,
				value: this.$i18n.t('all')
			},
			filterBy: [
				{
					key: undefined,
					value: this.$i18n.t('all')
				},
				// {
				// 	key: 1,
				// 	value: this.$i18n.t('payment.statuses.created')
				// },
				{
					key: 8,
					value: this.$i18n.t('paymentHistory.freePayment')
				},
				{
					key: 2,
					value: this.$i18n.t('payment.statuses.processing')
				},
				{
					key: 3,
					value: this.$i18n.t('payment.statuses.completed')
				},
				{
					key: 4,
					value: this.$i18n.t('payment.statuses.fail')
				},
				{
					key: 6,
					value: this.$i18n.t('payment.statuses.refund')
				},
				{
					key: 7,
					value: this.$i18n.t('payment.statuses.awaitingPayment')
				}
			],
			loading: false,
			fields: [
				{
					key: 'id',
					label: this.$i18n.t(
						'userDashboard.paymentHistory.fieldsPayment.receiptNumber'
					)
				},
				{
					key: 'created_at_day',
					label: this.$i18n.t('userDashboard.paymentHistory.fieldsPayment.date')
				},
				{
					key: 'created_at_time',
					label: this.$i18n.t('userDashboard.paymentHistory.fieldsPayment.time')
				},
				{
					key: 'total_amount',
					label: this.$i18n.t(
						'userDashboard.paymentHistory.fieldsPayment.amount'
					)
				},
				{
					key: 'status',
					label: this.$i18n.t(
						'userDashboard.paymentHistory.fieldsPayment.status'
					),
					tdClass: 'status-payment'
				},
				{ key: 'tooltip', label: '', tdClass: 'tooltip-table' }
			],
			showInfoTexInvoiceAddress: false,
			payment: {
				status: null
			},
			message: null,
			email: null,
			userId:null,
			paymentId:null,
			chargeId:null,
			paidBy:null,
			totalAmount:null
		};
	},
	computed: {
		...mapGetters({
			isMobile: 'UserController/isMobile'
		})
	},
	watch: {
		searchQuery: function(val) {
			this.loading = true;
			this.page = 1;
			if (!this.awaitingSearch) {
				setTimeout(() => {
					this.fetchUserPayments(true);
					this.awaitingSearch = false;
				}, 1000); // 1 sec delay
			}
			this.awaitingSearch = true;
		},
		page: function(val) {
			this.fetchUserPayments();
		}
	},
	mounted: function() {
		let date = new Date();
		this.dateFrom = new Date(date.setMonth(date.getMonth() - 1));
		this.dateTo = new Date();
		this.fetchUserPayments(true);
	},
	filters: {
		formatDate(value, lang) {
			if (!value) return;
			let now = moment(new Date());
			let newVal = moment(value);
			// if (now.isSame(newVal, "day")) return;
			return moment(value)
				.local('th')
				.format('DD MMM YYYY');
		},
		formatHour(value, lang) {
			if (!value) return;
			return moment(value)
				.local('th')
				.format('HH:mm');
		}
	},
	methods: {
		...mapActions('PaymentController', [
			actionType.FETCH_ADVANCED_USER_PAYMENTS,
			actionType.FETCH_ADVANCED_USER_PAYMENTS_DETAILS,
			actionType.SEND_INVOICE_OR_MESSAGE_TO_USER
		]),
		fetchUserPayments(filterd) {
			var vm = this;
			vm.loading = true;
			if (filterd) {
				vm.page = 1;
			}
			let obj={
				order_id: vm.searchQuery ? vm.searchQuery : undefined,
				from: vm.dateFrom,
				to: vm.dateTo,
				page: vm.page,
				showFreePayments: true
			}
			console.log("vm.selectedFilter",vm.selectedFilter)
			if(vm.selectedFilter.key==8){
				obj.showFreePayments = true;
			
			}else{
				obj.status= vm.selectedFilter.key
				obj.showFreePayments = false;
			}
			this.FETCH_ADVANCED_USER_PAYMENTS(obj).then(function(result) {
				vm.userPayments = result.data;
				vm.pageInfo = result.meta;
				vm.loading = false;
			});
		},
		gotoListingDetails(id) {
			this.$router.push(this.$i18nRoute({ name: 'listing-detail' }, id));
		},
		getBillDetails(invoiceId) {
			var vm = this;
			vm.loading = true;
			return this.FETCH_ADVANCED_USER_PAYMENTS_DETAILS({ id: invoiceId })
				.then(function(result) {
					vm.loading = false;
					return result;
				})
				.catch(err => {
					vm.loading = false;
					return result;
				});
		},
		showPaymentDetails(invoiceId) {
			var vm = this;
			vm.userPaymentsDetails = null;
			this.getBillDetails(invoiceId).then(result => {
				vm.userPaymentsDetails = result.data;
				// console.log(vm.userPaymentsDetails.payment_method_id!=4&&vm.userPaymentsDetails.payment_method_id!=5&&userPaymentsDetails.payment_method_id!==1)
				// if (vm.userPaymentsDetails && (vm.userPaymentsDetails.payment_method_id!=4&&vm.userPaymentsDetails.payment_method_id!=5&&userPaymentsDetails.payment_method_id!==7&&userPaymentsDetails.payment_method_id!==1)) {
				// 	this.paidBy=vm.userPaymentsDetails.user_payments_logs[0].name
				// 	this.userId=JSON.parse(vm.userPaymentsDetails.user_payments_logs[0].description).metadata.userId
				// 	this.chargeId=JSON.parse(vm.userPaymentsDetails.user_payments_logs[0].description).id
				// 	this.totalAmount=JSON.parse(vm.userPaymentsDetails.user_payments_logs[0].description).amount
				// 	this.paymentId=JSON.parse(vm.userPaymentsDetails.user_payments_logs[0].description).metadata.payment_id
					
				// }
				vm.$bvModal.show('payment-details-dialog');
			});
		},
		hideModal() {
			var vm = this;
			vm.$bvModal.hide('payment-details-dialog');
		},
		paginationNumber(pageNum) {
			return pageNum === 1 ? '?page=1' : `?page=${pageNum}`;
		},
		sendPaymentInvoice(payment) {
			var vm = this;
			vm.payment = payment;
			vm.$bvModal.show('sendMessage');
		},
		hidePaymentInvoice() {
			var vm = this;
			vm.payment = {
				status: null
			};
			vm.$bvModal.hide('sendMessage');
		},
		sendMessageToUser(payment) {
			let vm = this;
			vm.loading = true;
			let obj = { id: payment.id };
			if (vm.email) {
				obj.email = vm.email;
			}
			if (vm.message) {
				obj.message = vm.message;
			}
			vm.SEND_INVOICE_OR_MESSAGE_TO_USER(obj)
				.then(function(result) {
					vm.$bvToast.toast(this.$t('Send a message to the user'), {
						title: `Success!`,
						variant: 'primary',
						solid: true
					});
					vm.hidePaymentInvoice();

					vm.loading = false;
				})
				.catch(err => {
					vm.loading = false;
					return err;
				});
		},
		async copyText(text){
			 try {
				await navigator.clipboard.writeText(text);
					this.$bvToast.toast('Text Coppied', {
						title: `Success!`,
						variant: 'primary',
						solid: true
					});
				} catch($e) {
					alert('Cannot copy');
				}

		}
	}
};
</script>
<style lang="scss">
@import 'adminPaymentHistory.scss';
</style>
